import {Component, Injector, OnDestroy, OnInit} from '@angular/core';
import {SimpleModalService} from '@looorent/ngx-simple-modal';
import {ApiServiceBase} from 'src/app/Services/api.service.base';
import {Datalistviewcolumn} from 'src/app/shared/datalistview/columns/datalistviewcolumn';
import {SessionpaymentrefundComponent} from '../modals/sessionpaymentrefund/sessionpaymentrefund.component';
import {
  AddsessionmanualpaymentmodalComponent
} from '../modals/addsessionmanualpayment/addsessionmanualpaymentmodal.component';
import {EditsessionratesetmodalComponent} from '../modals/editsessionrateset/editsessionratesetmodal.component';
import {ModelEditor} from 'src/app/shared/editors/modeleditor';
import {StructureViewerLayer} from 'src/app/shared/structureviewermaps/structureviewerlayers';
import {CloseSessionComponent} from '../modals/close-session/close-session.component';
import {Subscription} from "rxjs";

@Component({
    selector: 'app-editsession',
    templateUrl: './editsession.component.html',
    styleUrls: ['./editsession.component.scss'],
    standalone: false
})
export class EditsessionComponent extends ModelEditor implements OnInit, OnDestroy {
  public Columns : Array<Datalistviewcolumn> = [
    new Datalistviewcolumn("AccountTransactionId", "AccountTransactionId"),
    new Datalistviewcolumn("Amount", "Amount"),
    new Datalistviewcolumn("PaidFrom", "PaidFrom"),
    new Datalistviewcolumn("PaidTo", "PaidTo"),
    new Datalistviewcolumn("PaymentType", "PaymentType"),
    new Datalistviewcolumn("TransactionId", "TransactionId"),
    new Datalistviewcolumn("TransactionReference", "TransactionReference")
  ];

  public StructureViewerLayers: StructureViewerLayer[] = [];
  public StructureSearchTerm!: string;
  public StructureId !: string;
  public StructureViewerForType !: string;

  private subscriptions: Subscription[] = [];

  constructor(private modalService: SimpleModalService, private apiService: ApiServiceBase, private injector: Injector) {
    super("parking/sessions", injector);
    this.QueryString = "?quote=false";
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  public DefaultModel() {
    return {
      Id: null,
      ParkingSpaceId: null
    }
  }

  public Validators() {
  }

  public override AfterModelLoaded(): void {
    this.StructureViewerLayers = [];
    if(this.Model.ParkingSpaceId != null){
      this.StructureViewerLayers.push(new StructureViewerLayer("ParkingLot"));
      this.StructureViewerLayers.push(new StructureViewerLayer("ParkingLevel"));
      this.StructureViewerLayers.push(new StructureViewerLayer("ParkingSpace"));
      this.StructureSearchTerm = this.Model.ParkingSpaceId;
      this.StructureId = this.Model.ParkingSpaceId;
      this.StructureViewerForType = "ParkingSpace";
    }
    else if(this.Model.ControlledAreaId != null){
      this.StructureViewerLayers.push(new StructureViewerLayer("ControlledArea"))
      this.StructureViewerLayers.push(new StructureViewerLayer("ParkingLot"));
      this.StructureId = this.Model.ControlledAreaId;
      this.StructureViewerForType = "ControlledArea";
    }
  }

  public override BeforeSave(): void {

  }

  public Receipt(p : any){
    window.open(p.PublicPortalReceiptUrl, '_blank')?.focus();
  }

  public async RecordRefund(p: any) {
    this.subscriptions.push(this.modalService.addModal(SessionpaymentrefundComponent, { Payment: p})
      .subscribe((result) => {
        if (result != null) {
          this.FetchModel(this.Model.Id);
        }
      }));
  }

  public MakeManualPayment(){
    this.subscriptions.push(this.modalService.addModal(AddsessionmanualpaymentmodalComponent, {Session: this.Model})
      .subscribe(() => {
        this.FetchModel(this.ModelId);
      }));
  }

  public ChangeRateSet(){
    this.subscriptions.push(this.modalService.addModal(EditsessionratesetmodalComponent, {Session: this.Model})
      .subscribe(() => {
        this.FetchModel(this.ModelId);
      }));
  }
  public CloseSession() {
    this.subscriptions.push(this.modalService.addModal(CloseSessionComponent, { session: this.Model })
      .subscribe((result) => {
        if (result != null) {
          this.FetchModel(this.ModelId);
        }
      }));
  }

  public ValueFollowedByComma(value: string): string {
    return value ? `${value}, ` : '';
  }

  public IsHotelReservationPermit(): boolean {
    return this.Model?.ParkingPermitInstance?.ParkingPermit?.ParkingPermitType?.PermitType === 'HotelReservationParkingPermitType';
  }

  public PermitDetailsRoute(): string {
    const permitId = this.Model?.ParkingPermitInstance?.ParkingPermit?.Id;
    if (this.IsHotelReservationPermit())
      return `/permits/hotelreservations/${permitId}`;

    return `/permits/parkingpermits/${permitId}`;
  }
}
